import { QuestionCircleOutlined } from "@ant-design/icons";
import { Tooltip, TooltipProps } from "antd";
import { FC } from "react";

type ColumnHeaderTitleProps = {
    columnTitle: string;
} & TooltipProps;

export const ColumnHeaderTitle: FC<ColumnHeaderTitleProps> = ({ columnTitle, title, placement = "topLeft" }) => {
    return (
        <>
            <span>{columnTitle}</span>
            {title && (
                <Tooltip placement={placement} title={title} className="ml-1">
                    <QuestionCircleOutlined />
                </Tooltip>
            )}
        </>
    );
};
